import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid ${th('colors.confetti+2')};
  background-color: ${th('colors.confetti+1')};

  > * {
    flex: 1;
  }

  @media ${sizes.tabletPortrait} {
    padding: 0;
    border-top: none;
    background-color: transparent;

    > * {
      flex: initial;
    }
  }
`;
